import Vue from 'vue'
import loading from '@/shared/plugins/loading'
import { removeCookieModulo } from './cookies'
import { contextoContabil } from './modulos'

const URL_DASHBOARD_PADRAO = '/inicio'
const URL_DASHBOARD_CONTABILIDADE = '/contabilidade/inicio'

/**
 * URL do painel inicial da sessão.
 *
 * O backend entrega em `Modalidade.url_dashboard` a rota do painel de cada contexto —
 * inclusive `/contabilidade/inicio` quando a sessão é do portal contábil
 * (`UsuarioComponent::formata_navegacao_portal`, GCK-20889).
 */
export const pegaUrlDashboard = () => {
    const usuarioLogado = Vue.prototype.$usuarioLogado
    if (
        usuarioLogado
        && usuarioLogado.Modalidade
        && usuarioLogado.Modalidade.url_dashboard
    ) {
        return usuarioLogado.Modalidade.url_dashboard
    }
    // Sem sessão carregada — é o caso das páginas de erro, que não montam o layout
    // Interno e por isso nunca chamam `carregaUsuarioLogado`. O portal contábil tem
    // painel próprio; o resto cai no do ERP. GCK-20891 (E-16).
    if (contextoContabil()) {
        return URL_DASHBOARD_CONTABILIDADE
    }
    return URL_DASHBOARD_PADRAO
}

/**
 * Diz se a URL continua dentro do módulo em que a sessão está (`$urlBase`).
 * Fora de módulo (`$urlBase` vazio) qualquer destino é "outro módulo".
 */
export const destinoDentroDoModulo = (url) => {
    const urlBase = Vue.prototype.$urlBase
    if (!urlBase || !url) {
        return false
    }
    return url === urlBase || url.indexOf(urlBase + '/') === 0
}

/**
 * Navega para o painel inicial.
 *
 * `removeCookieModulo()` serve ao caminho "sair do módulo e voltar para a raiz do ERP":
 * apaga o `sessionStorage 'modulo'`, que é o que diz ao topo em qual módulo a sessão
 * está. Quando o destino é o painel do PRÓPRIO módulo — o caso do portal contábil, em
 * que a logomarca aponta para `/contabilidade/inicio` —, apagar derruba o contexto e o
 * topo volta a se montar como se fosse o ERP; era isso que fazia o contador "perder" o
 * portal. Aqui o módulo só é esquecido quando o destino realmente sai dele.
 *
 * GCK-20889 (E-01/E-02).
 */
export const acessaDashboard = (url = null) => {
    const destino = url || pegaUrlDashboard()
    if (!destinoDentroDoModulo(destino)) {
        removeCookieModulo()
    }
    loading.show()
    window.location.href = destino
}
